import { Loader } from '@mantine/core';
export const loaderProps = Loader.extend({
    defaultProps: {
        color: 'ocean',
    },
});
